import { render, staticRenderFns } from "./ColonFindingInfoGroup.vue?vue&type=template&id=4c551308&scoped=true&"
import script from "./ColonFindingInfoGroup.vue?vue&type=script&lang=js&"
export * from "./ColonFindingInfoGroup.vue?vue&type=script&lang=js&"
import style0 from "./ColonFindingInfoGroup.vue?vue&type=style&index=0&id=4c551308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c551308",
  null
  
)

export default component.exports